module.exports = __webpack_public_path__ + "img/lukuangbtns.6876a6fb.png";